import React from 'react';
import * as S from './styles';

const ContentWrapper = (props = {}) => (
    <S.Wrapper>
        {React.Children.map(props.children, (child, idx) => React.cloneElement(child, {
            order: idx + 1,
        }))}
    </S.Wrapper>
);

export default ContentWrapper;
